import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import userReducer from './slices/user';
import merchantListReducer from './slices/merchantList';
import giftCardReducer from './slices/giftCard';
import faqReducer from './slices/faq';
import promotionReducer from './slices/promotion';
import merchantReducer from './slices/merchant';
import menuReducer from './slices/menu';
import orderReducer from './slices/order';
import bookingSessionsReducer from './slices/booking-sessions';
import bookingReducer from './slices/booking';
import productReducer from './slices/product';
import kanbanReducer from './slices/kanban';
import authReducer from './slices/auth';
import loyaltyReducer from './slices/loyalty';
import membershipReducer from './slices/membership';
import appSectionReducer from './slices/appSection';
import promotionsManagementReducer from './slices/promotions-management';
import floormapReducer from './slices/floormap';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: []
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-'
  // whitelist: ['sortBy', 'checkout']
};

const authPersistConfig = {
  key: 'auth',
  storage,
  keyPrefix: 'redux-'
  // whitelist: ['sortBy', 'checkout']
};

const merchantListPersistConfig = {
  key: 'merchantList',
  storage,
  keyPrefix: 'redux-'
};

const giftCardPersistConfig = {
  key: 'giftCard',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['preferredContactMethod']
};

const floormapPersistConfig = {
  key: 'floormap',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['devicePreferencesByMerchant']
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  user: userReducer,
  promotion: promotionReducer,
  loyalty: loyaltyReducer,
  membership: membershipReducer,
  merchant: merchantReducer,
  appSection: appSectionReducer,
  menu: menuReducer,
  order: orderReducer,
  bookingSessions: bookingSessionsReducer,
  promotionsManagement: promotionsManagementReducer,
  booking: bookingReducer,
  floormap: persistReducer(floormapPersistConfig, floormapReducer),
  kanban: kanbanReducer,
  giftCard: persistReducer(giftCardPersistConfig, giftCardReducer),
  FAQ: faqReducer,
  product: persistReducer(productPersistConfig, productReducer),
  auth: persistReducer(authPersistConfig, authReducer),
  merchantList: persistReducer(merchantListPersistConfig, merchantListReducer)
});

export { rootPersistConfig, rootReducer };
